export class ltiLaunchDB {
    name: string;
    url: string;
    consumerKey: string;
    consumerSecret: string;
    params: paramsDB[];
}
export class paramsDB {
    name: string;
    value: string;
    isConstant: Boolean;
    link?: string;
}
export class SumadiData {
    username: string;
    password: string;
    sessions: number[];
}


export enum userTipeLTI {
    ESTUDENT = 'E',
    SUPERVISOR = 'S'
}